import { mapState, mapGetters } from 'vuex';
import { getProductExtraCoinDisplay } from '@utiles/officialWebStore/productExtraCoinDisplay';

export default {
  computed: {
    ...mapState({
      gameId: state => state.gameId,
      lang: state => state.lang
    }),
    ...mapGetters(['coinIco']),
    productExtraCoinProduct() {
      if (this.productExtraCoinFromItem) {
        return this.item;
      }
      return this.curProduct;
    },
    productExtraCoinDisplay() {
      return getProductExtraCoinDisplay({
        gameId: this.gameId,
        product: this.productExtraCoinProduct,
        lang: this.lang,
        defaultName: this.$store.state.coinName,
        defaultIco: this.coinIco
      });
    },
    productExtraCoinIco() {
      return this.productExtraCoinDisplay.ico;
    },
    productExtraCoinName() {
      return this.productExtraCoinDisplay.name;
    }
  }
};
